/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseBannerBlockGroesse } from './DatabaseBannerBlockGroesse';
import {
    DatabaseBannerBlockGroesseFromJSON,
    DatabaseBannerBlockGroesseFromJSONTyped,
    DatabaseBannerBlockGroesseToJSON,
} from './DatabaseBannerBlockGroesse';
import type { DatabaseBannerDatensatzWahl } from './DatabaseBannerDatensatzWahl';
import {
    DatabaseBannerDatensatzWahlFromJSON,
    DatabaseBannerDatensatzWahlFromJSONTyped,
    DatabaseBannerDatensatzWahlToJSON,
} from './DatabaseBannerDatensatzWahl';
import type { DatabaseBannerHoehe } from './DatabaseBannerHoehe';
import {
    DatabaseBannerHoeheFromJSON,
    DatabaseBannerHoeheFromJSONTyped,
    DatabaseBannerHoeheToJSON,
} from './DatabaseBannerHoehe';
import type { DatabaseBannerKarten } from './DatabaseBannerKarten';
import {
    DatabaseBannerKartenFromJSON,
    DatabaseBannerKartenFromJSONTyped,
    DatabaseBannerKartenToJSON,
} from './DatabaseBannerKarten';
import type { DatabaseBannerStile } from './DatabaseBannerStile';
import {
    DatabaseBannerStileFromJSON,
    DatabaseBannerStileFromJSONTyped,
    DatabaseBannerStileToJSON,
} from './DatabaseBannerStile';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseKlappzeile } from './DatabaseKlappzeile';
import {
    DatabaseKlappzeileFromJSON,
    DatabaseKlappzeileFromJSONTyped,
    DatabaseKlappzeileToJSON,
} from './DatabaseKlappzeile';
import type { DatabasePageBlock } from './DatabasePageBlock';
import {
    DatabasePageBlockFromJSON,
    DatabasePageBlockFromJSONTyped,
    DatabasePageBlockToJSON,
} from './DatabasePageBlock';
import type { DatabasePageBlockActionType } from './DatabasePageBlockActionType';
import {
    DatabasePageBlockActionTypeFromJSON,
    DatabasePageBlockActionTypeFromJSONTyped,
    DatabasePageBlockActionTypeToJSON,
} from './DatabasePageBlockActionType';
import type { DatabaseSubDbListLayout } from './DatabaseSubDbListLayout';
import {
    DatabaseSubDbListLayoutFromJSON,
    DatabaseSubDbListLayoutFromJSONTyped,
    DatabaseSubDbListLayoutToJSON,
} from './DatabaseSubDbListLayout';

/**
 * 
 * @export
 * @interface DatabaseBannerPageBlock
 */
export interface DatabaseBannerPageBlock extends DatabasePageBlock {
    /**
     * Die Unterdatenbank, deren Datensaetze das Band zeigt.
     * @type {string}
     * @memberof DatabaseBannerPageBlock
     */
    childDatabaseId?: string;
    /**
     * 
     * @type {DatabaseSubDbListLayout}
     * @memberof DatabaseBannerPageBlock
     */
    layout?: DatabaseSubDbListLayout;
    /**
     * Bestimmt jeder Datensatz seine Art selbst? Dann steht hier das
     * Feld — fuer mehrere verschiedene Baender im Wechsel (Kriterium 3
     * der Vorgabe: sechs Banner, jedes anders).
     * @type {string}
     * @memberof DatabaseBannerPageBlock
     */
    layoutFieldId?: string;
    /**
     * 
     * @type {DatabaseBannerHoehe}
     * @memberof DatabaseBannerPageBlock
     */
    hoehenModus?: DatabaseBannerHoehe;
    /**
     * 
     * @type {DatabaseBannerBlockGroesse}
     * @memberof DatabaseBannerPageBlock
     */
    blockGroesse?: DatabaseBannerBlockGroesse;
    /**
     * 
     * @type {DatabaseBannerStile}
     * @memberof DatabaseBannerPageBlock
     */
    bannerStile?: DatabaseBannerStile;
    /**
     * 
     * @type {DatabaseBannerDatensatzWahl}
     * @memberof DatabaseBannerPageBlock
     */
    datensatzWahl?: DatabaseBannerDatensatzWahl;
    /**
     * NUR BEI `BESTIMMT`: Nach diesem Feld werden die Datensaetze in der
     * Auswahl aufgelistet. Ohne Angabe das Feld der Rolle
     * „Ueberschrift".
     * @type {string}
     * @memberof DatabaseBannerPageBlock
     */
    datensatzFeldId?: string;
    /**
     * NUR BEI `BESTIMMT` — der gewaehlte Datensatz.
     * @type {string}
     * @memberof DatabaseBannerPageBlock
     */
    datensatzId?: string;
    /**
     * 
     * @type {DatabaseBannerKarten}
     * @memberof DatabaseBannerPageBlock
     */
    kartenAuswahl?: DatabaseBannerKarten;
    /**
     * Nur bei `kartenAuswahl: AUSWAHL` — die NAMEN der Karten.
     * (Ein Doppelpunkt mit Leerzeichen im einzeiligen Text macht daraus
     * eine Zuordnung — deshalb als Block.)
     * @type {Array<string>}
     * @memberof DatabaseBannerPageBlock
     */
    karten?: Array<string>;
    /**
     * Der Takt, in dem das Band weiterblaettert. 0 oder leer = kein
     * Wechsel, dann stehen alle Datensaetze untereinander.
     * @type {number}
     * @memberof DatabaseBannerPageBlock
     */
    rotationSeconds?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseBannerPageBlock
     */
    bildFeldId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseBannerPageBlock
     */
    badgeFeldId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseBannerPageBlock
     */
    ueberschriftFeldId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseBannerPageBlock
     */
    textFeldId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseBannerPageBlock
     */
    zielgruppeFeldId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseBannerPageBlock
     */
    labelFeldId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseBannerPageBlock
     */
    buttonFeldId?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseBannerPageBlock
     */
    iconFeldId?: string;
    /**
     * Der Text, den das Detail-Popup beim Antippen zeigt.
     * @type {string}
     * @memberof DatabaseBannerPageBlock
     */
    popupFeldId?: string;
    /**
     * Wohin der Klick fuehrt, wenn kein Popup gesetzt ist.
     * @type {string}
     * @memberof DatabaseBannerPageBlock
     */
    linkFeldId?: string;
    /**
     * DAS FELD, DAS SEIN AUSSEHEN SELBST MITBRINGT (Betreiber
     * 22.09.2026). Gemeint ist ein Textfeld MIT Formatierung: Was dort
     * im Editor gestaltet wurde — Farben, Schrift, Aufbau, die
     * Gestaltungsbausteine — zeigt die Art `FREIE_GESTALTUNG`
     * unveraendert ueber die ganze Flaeche.
     * 
     * Sein Anlass: drei Anzeigen, jede in eigenen Farben. Die ART kommt
     * seit dem 22.09. je Datensatz, die FARBEN sassen am Baustein und
     * galten fuer alle gleich. Statt eigener Farbfelder — sein
     * Vorschlag — bringt jeder Datensatz seine Gestaltung mit.
     * @type {string}
     * @memberof DatabaseBannerPageBlock
     */
    gestaltungFeldId?: string;
}

/**
 * Check if a given object implements the DatabaseBannerPageBlock interface.
 */
export function instanceOfDatabaseBannerPageBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseBannerPageBlockFromJSON(json: any): DatabaseBannerPageBlock {
    return DatabaseBannerPageBlockFromJSONTyped(json, false);
}

export function DatabaseBannerPageBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseBannerPageBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabasePageBlockFromJSONTyped(json, ignoreDiscriminator),
        'childDatabaseId': !exists(json, 'childDatabaseId') ? undefined : json['childDatabaseId'],
        'layout': !exists(json, 'layout') ? undefined : DatabaseSubDbListLayoutFromJSON(json['layout']),
        'layoutFieldId': !exists(json, 'layoutFieldId') ? undefined : json['layoutFieldId'],
        'hoehenModus': !exists(json, 'hoehenModus') ? undefined : DatabaseBannerHoeheFromJSON(json['hoehenModus']),
        'blockGroesse': !exists(json, 'blockGroesse') ? undefined : DatabaseBannerBlockGroesseFromJSON(json['blockGroesse']),
        'bannerStile': !exists(json, 'bannerStile') ? undefined : DatabaseBannerStileFromJSON(json['bannerStile']),
        'datensatzWahl': !exists(json, 'datensatzWahl') ? undefined : DatabaseBannerDatensatzWahlFromJSON(json['datensatzWahl']),
        'datensatzFeldId': !exists(json, 'datensatzFeldId') ? undefined : json['datensatzFeldId'],
        'datensatzId': !exists(json, 'datensatzId') ? undefined : json['datensatzId'],
        'kartenAuswahl': !exists(json, 'kartenAuswahl') ? undefined : DatabaseBannerKartenFromJSON(json['kartenAuswahl']),
        'karten': !exists(json, 'karten') ? undefined : json['karten'],
        'rotationSeconds': !exists(json, 'rotationSeconds') ? undefined : json['rotationSeconds'],
        'bildFeldId': !exists(json, 'bildFeldId') ? undefined : json['bildFeldId'],
        'badgeFeldId': !exists(json, 'badgeFeldId') ? undefined : json['badgeFeldId'],
        'ueberschriftFeldId': !exists(json, 'ueberschriftFeldId') ? undefined : json['ueberschriftFeldId'],
        'textFeldId': !exists(json, 'textFeldId') ? undefined : json['textFeldId'],
        'zielgruppeFeldId': !exists(json, 'zielgruppeFeldId') ? undefined : json['zielgruppeFeldId'],
        'labelFeldId': !exists(json, 'labelFeldId') ? undefined : json['labelFeldId'],
        'buttonFeldId': !exists(json, 'buttonFeldId') ? undefined : json['buttonFeldId'],
        'iconFeldId': !exists(json, 'iconFeldId') ? undefined : json['iconFeldId'],
        'popupFeldId': !exists(json, 'popupFeldId') ? undefined : json['popupFeldId'],
        'linkFeldId': !exists(json, 'linkFeldId') ? undefined : json['linkFeldId'],
        'gestaltungFeldId': !exists(json, 'gestaltungFeldId') ? undefined : json['gestaltungFeldId'],
    };
}

export function DatabaseBannerPageBlockToJSON(value?: DatabaseBannerPageBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabasePageBlockToJSON(value),
        'childDatabaseId': value.childDatabaseId,
        'layout': DatabaseSubDbListLayoutToJSON(value.layout),
        'layoutFieldId': value.layoutFieldId,
        'hoehenModus': DatabaseBannerHoeheToJSON(value.hoehenModus),
        'blockGroesse': DatabaseBannerBlockGroesseToJSON(value.blockGroesse),
        'bannerStile': DatabaseBannerStileToJSON(value.bannerStile),
        'datensatzWahl': DatabaseBannerDatensatzWahlToJSON(value.datensatzWahl),
        'datensatzFeldId': value.datensatzFeldId,
        'datensatzId': value.datensatzId,
        'kartenAuswahl': DatabaseBannerKartenToJSON(value.kartenAuswahl),
        'karten': value.karten,
        'rotationSeconds': value.rotationSeconds,
        'bildFeldId': value.bildFeldId,
        'badgeFeldId': value.badgeFeldId,
        'ueberschriftFeldId': value.ueberschriftFeldId,
        'textFeldId': value.textFeldId,
        'zielgruppeFeldId': value.zielgruppeFeldId,
        'labelFeldId': value.labelFeldId,
        'buttonFeldId': value.buttonFeldId,
        'iconFeldId': value.iconFeldId,
        'popupFeldId': value.popupFeldId,
        'linkFeldId': value.linkFeldId,
        'gestaltungFeldId': value.gestaltungFeldId,
    };
}

